export default {
  NotCheckLicense: 0, // TH không có thông tin suman hoặc trường isCheckLicense = false ở bảng tenant
  TwoTerms: 1, // tách riêng
  OneTerm: 2, // gộp chung
  UsageOnly: 3, // chỉ thỏa thuận sử dụng
};
